require('./RADistributionModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKLink } = require('commonsComponents/OKLink');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @components
const RAAccordionDistributionTable = require('../RAAccordionDistributionTable/RAAccordionDistributionTable');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @constants
const { DISTRIBUTION_MODAL_OPTION_TOTAL } = require('../../raConstants/index');

class RADistributionModal extends React.Component {
    buildOptions(immPortfolios) {
        const firstOption = {
            label: formatText('raDistributionModal-raDistributionModal_total'),
            value: DISTRIBUTION_MODAL_OPTION_TOTAL,
        };

        const options = immPortfolios.entrySeq().map(entry => {
            const immPortfolio = entry[1];
            return {
                label: immPortfolio.get('name'),
                value: immPortfolio.get('id'),
            };
        });

        return options.toList().unshift(firstOption);
    }

    render() {
        const {
            immAssetAllocations,
            immPortfolios,
            immRoboAdvisor,
            isOpen,
            selectedPortfolio,
        } = this.props;
        const options = this.buildOptions(immPortfolios);
        const isPortfolioSelected =
            !!selectedPortfolio &&
            selectedPortfolio !== DISTRIBUTION_MODAL_OPTION_TOTAL;
        let currentAssetAllocations;
        let currentKeyFigures;
        let link;

        if (isPortfolioSelected) {
            const portfolioDetailsURL = `/myprofile/robo/portfolioTracking/${selectedPortfolio}`;
            currentAssetAllocations = immPortfolios.getIn([
                selectedPortfolio,
                'assetAllocation',
            ]);
            currentKeyFigures = immPortfolios.getIn([
                selectedPortfolio,
                'keyFigures',
            ]);
            link = (
                <OKLink
                    to={portfolioDetailsURL}
                    modifier="complementary"
                    inverse={false}
                >
                    <FormattedText value="raDistributionModal-raDistributionModal_link" />
                </OKLink>
            );
        } else {
            currentAssetAllocations = immAssetAllocations;
            currentKeyFigures = immRoboAdvisor.get('totals');
            link = (
                <OKLink to="" modifier="widget" inverse={true}>
                    <FormattedText value="raDistributionModal-raDistributionModal_link" />
                </OKLink>
            );
        }
        const footerLink =
            selectedPortfolio === DISTRIBUTION_MODAL_OPTION_TOTAL ? '' : link;

        return (
            <ModalCustom
                isOpen={isOpen}
                extraClass="ra-distribution-modal"
                onAfterOpen={this.props.onDistributionModalOptionChange}
                onRequestClose={this.props.onCloseModal}
            >
                <section role="modalScrollableContent">
                    <header className="ra-distribution-modal__header">
                        <FormattedText
                            value="raDistributionModal-raDistributionModal_title"
                            className="ra-distribution-modal__title"
                        />
                        <div className="ra-distribution-modal__dropdown">
                            <OKSelect
                                clearable={false}
                                onChange={
                                    this.props.onDistributionModalOptionChange
                                }
                                options={options.toJS()}
                                value={selectedPortfolio}
                                defaultValue={DISTRIBUTION_MODAL_OPTION_TOTAL}
                            />
                        </div>
                    </header>
                    <RAAccordionDistributionTable
                        immKeyFigures={currentKeyFigures}
                        immAssetAllocations={currentAssetAllocations}
                        scroll={true}
                        showRentabilityPercentage={isPortfolioSelected}
                    />
                    <footer className="ra-distribution-modal__footer">
                        {footerLink}
                    </footer>
                </section>
            </ModalCustom>
        );
    }
}

RADistributionModal.propTypes = {
    immAssetAllocations: PropTypes.object.isRequired,
    immPortfolios: PropTypes.object.isRequired,
    immRoboAdvisor: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    onDistributionModalOptionChange: PropTypes.func.isRequired,
    selectedPortfolio: PropTypes.string,
};

module.exports = RADistributionModal;
